<div class="content-body">
  <div class="content-title">Stored Procedures</div>
  <div class="description" style="margin-top: 16px;"> 
    <ul>
      <li>Consists of predefined actions for an operator to execute.  </li>
      <li>Assists in a consistent operator response.  </li>
      <li>Assists operators in a tiered response based on the site's service agreement.  </li>
      <li>Up to 4 procedures can be registered per direction.</li>
    </ul>
  </div>
  <hr/>
  <div class="content-subtitle">Response Level</div>
  <div class="description"> 
    <ul>
      <li>Allows the dealer to define a tiered response and code name.</li>
    </ul>
    <div class="position-tag">
      <div class="v-center" (mouseenter)="mouseEnterShowPosition($event, 'procedure-level')" (mouseleave)="mouseLeaveHidePosition($event)"><i class="material-icons">my_location</i>
        <div>Where is it?</div>
      </div>
    </div>
  </div>
  <div class="content-subtitle" style="margin-top:32px">Stored Actions</div>
  <div class="description"> 
    <ul>
      <li>Allows the dealer to define a series of actions that will all occur when the operator executes the procedure. </li>
    </ul><br/>
    <div>[ List of available actions ]</div>
    <ul style="padding-inline-start: 30px;"> 
      <li>Talkdown  </li>
      <li>Relay  </li>
      <li>2 min Playback  </li>
      <li>Verification  </li>
      <li>Send Response Link  </li>
      <li>Send Download Link  </li>
      <li>Http Actions</li>
    </ul>
  </div>
</div>